import { render } from "./NeurologicalDiseaseProjectOverview.vue?vue&type=template&id=4c8cdee8&scoped=true"
import script from "./NeurologicalDiseaseProjectOverview.vue?vue&type=script&lang=js"
export * from "./NeurologicalDiseaseProjectOverview.vue?vue&type=script&lang=js"

import "./NeurologicalDiseaseProjectOverview.vue?vue&type=style&index=0&id=4c8cdee8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8cdee8"]])

export default __exports__